import product from '@/shared/datasets/products';

export default {
  title: 'GQ BOX X FIGHTCAMP STARTER PACKAGE',
  id: 'gq_fightcamp_trackers',
  text: 'Our essentials package',
  description: 'Get the essentials you need to start your FightCamp journey. Track your progress, compete against others, and access on-demand workouts led by expert trainers. Please enter your GQ code at checkout to redeem your exclusive offer.',
  product: product.gqFightcampTrackers,
  category: 'package',
  coverImage: '/v4/fc-fightcamp-base-002.png',
  coverImageAlt: 'Fightcamp quick wraps and trackers',
  secondaryImage: '/v4/fc-fightcamp-base-man-shadowboxing-001.jpeg',
  secondaryImageAlt: 'Man with fightcamp base shadowboxing',
  includes: [
    {
      name: 'Trackers',
      image: {
        src: 'v4/fc-product-includes-trackers-002.png',
        alt: 'FightCamp Trackers',
      },
      carouselImages: [
        {
          src: 'https://a.storyblok.com/f/152150/4216x3168/75f1824a85/fc-package-woman-putting-wraps-on-003.png',
          alt: 'Woman putting trackers into FightCamp quick wraps',
        },
        {
          src: 'https://a.storyblok.com/f/152150/4216x3169/9fd7d6f0fc/fc-package-tracker-wrap-002.png',
          alt: 'FightCamp trackers',
        },
      ],
      description: 'Our cutting-edge sensors unlock all of the most powerful FightCamp features. Used by many of the top Fighters in the world, they track and display punch volume, speed and Output in real time. Watch your punch count climb & compete against others all while having fun doing it.',
    },
    {
      name: 'Quick Wraps',
      image: {
        src: 'v4/fc-product-includes-wraps-001.png',
        alt: 'FightCamp Quick Wraps',
      },
      description: 'Our premium training gloves are 100% hand-made, ultra comfortable, and super durable. Small gloves are best for low-to-mid power strikes. Large gloves offer more padding & add weight for heavy hitters.',
    },
    {
      name: '45-Day Trial',
      image: {
        src: 'https://a.storyblok.com/f/152150/592x542/07e22bebea/fc-glove-fire-graphic-001.png',
        alt: 'FightCamp Membership with 45 day trial',
      },
      description: 'Use your code to redeem a 45-day free trial and get access to on-demand workouts led by expert trainers, track your progress, compete against others, and more.',
    },
  ],
  upsell: [
    {
      name: 'FightCamp Gloves',
      description: '100% hand-made, ultra comfortable, and super durable. ',
      image: '/v4/fc-additional-items-gloves-001.png',
      imageAlt: 'FightCamp Boxing Gloves',
      productVariants: [
        {
          name: 'Light Gloves (12 oz)',
          itemId: 'customGloves_V2_S',
          description: 'Best for low-to-mid power strikes.',
          product: product.glovesv2,
        },
        {
          name: 'Heavy Gloves (16 oz)',
          itemId: 'customGloves_V2_L',
          description: 'More padding & weight for heavy hitters.',
          product: product.glovesv2,
        },
        {
          name: 'Kids Gloves (6 oz)',
          itemId: 'customGloves_V2_K',
          description: 'Get the kids involved.',
          product: product.kidsglovesv2,
        },
      ],
    },
    {
      name: 'FightCamp Free-Standing Bag',
      description: null,
      additionalInformation: "The FightCamp Free-Standing Boxing Bag is beautifully designed to look great in your home. It fits in a just about any space (it's only 2ft wide and 5ft 7in tall). It holds about 250 lbs of water or 350 lbs of sand.",
      image: product.bagv3.img_url,
      imageAlt: 'FightCamp Free-Standing Bag',
      product: product.bagv3,
      itemId: product.bagv3.id,
    },
  ],
  bonusOptions: [],
  selects: [{
    name: 'Quick Wraps Size',
    key: 'pair1',
    htc: 'How To Choose the Size',
    hint: 'Choose your size',
    value: 's',
    options: [{
      key: 's',
      name: 'Small',
      htc: 'Ideal for small to medium size hands.',
    },
    {
      key: 'l',
      name: 'Large',
      htc: 'Ideal for larger hands.',
    },
    ],
  }],
  variants: [{
    keys: {
      pair1: 's',
    },
    sku: 'gq_fightcamp_trackers_S',
  },
  {
    keys: {
      pair1: 'l',
    },
    sku: 'gq_fightcamp_trackers_L',
  },
  ],
};
